<div class="d-flex flex-column">
  <!-- Black&White Infos -->
  <div class="bwInfos">
    <div class="d-flex flex-row">
      <table class="table table-borderless">
        <thead>
          <tr>
            <th>
              <img class="bwImage" src="assets/icons/probesFamilies/black&White.png" alt="B&W">
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">{{ 'report-modal-bw-policy-version' | translate }}</th>
            @if (getlength(objetCourant?.bwInfo?.bwPolicyVersion) > 45) {
            <td class="value">
              <p type="button" placement="center" [closeDelay]="4000"
                ngbTooltip="{{objetCourant?.bwInfo?.bwPolicyVersion}}">
                {{ formatN(objetCourant?.bwInfo?.bwPolicyVersion, 45) }}
              </p>
            </td>
            } @else {
            <td>{{ objetCourant?.bwInfo?.bwPolicyVersion }}</td>
            }
          </tr>
          <tr>
            <th scope="row">{{ 'report-modal-bw-sdk' | translate }}</th>
            <td class="value">
              <p type="button" placement="top" [closeDelay]="4000" ngbTooltip="{{objetCourant?.bwInfo?.bwSdkVersion}}">
                {{ formatN(objetCourant?.bwInfo?.bwSdkVersion, 45) }}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- App Infos -->
  <div class="appInfos d-flex flex-row justify-content-between align-items-center">
    <div class="d-fex flex-column">
      <div class="d-flex flex-row align-items-center justify-content-between">
        @if (objetCourant?.appInfo?.appName) {
        <h4>{{ objetCourant?.appInfo?.appName }}</h4>
        <button class="btn btn-outline-primary align-self-center" (click)="getApp()" style="height: 25%">
          {{ 'attestations-modal-button-all' | translate }} {{ objetCourant?.appInfo?.appName }}
        </button>
        } @else {
        <h4>{{ objetCourant?.appInfo?.appId }}</h4>
        <button class="btn btn-outline-primary" (click)="getID()">
          {{ 'attestations-modal-button-all' | translate }} {{ objetCourant?.appInfo?.appId }}
        </button>
        }
      </div>
      <table class="table table-borderless table-responsive infosapp">
        <thead>
          <tr>
            <th>Version</th>
            <th>{{ "modal-installation-date" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            @if (objetCourant?.appInfo?.appVersion) {
            <th scope="row" class="entete">{{ objetCourant?.appInfo?.appVersion }}</th>
            } @else {
            <th scope="row">{{ 'unknown-app-version' | translate }}</th>
            }
            @if (objetCourant?.appInfo?.appInstallationTimestamp) {
            <td class="value d-flex flex-row justify-content-center">
              <img class="installed" src="assets/icons/ModalReports/installed.svg" alt="Install the">
              {{ getApptimeStamp() }}
            </td>
            } @else {
            <td>{{ 'unknown-app-installation-date' | translate }}</td>
            }
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Device Infos -->
<div class="deviceInfos d-flex flex-column {{objetCourant?.deviceInfo?.platformName?.toLowerCase()}}-infos">
  @if (objetCourant?.deviceInfo?.platformName?.toLowerCase() == 'ios' ||
  objetCourant?.deviceInfo?.platformName?.toLowerCase() == 'ipados') {
  <div class="d-flex flex-row justify-content-between headios">
    <div class="marque d-flex flex-row ">
      <img src="assets/icons/ModalReports/manufacters/apple.svg">
      <h2>{{ formatName(objetCourant?.deviceInfo?.model) }}</h2>
    </div>
    <div class="osinfos d-flex flex-row">
      <img class="os{{objetCourant?.deviceInfo?.platformName?.toLowerCase()}}"
        src="assets/icons/logosOS/{{objetCourant?.deviceInfo?.platformName?.toLowerCase()}}.svg">
      <h2>v.{{ objetCourant?.deviceInfo?.apiLevel }}</h2>
    </div>
  </div>
  <table class="table table-borderless table-responsive">
    <tbody>
      <tr>
        <th scope="row">{{ 'report-modal-device-id' | translate }}</th>
        @if (getlength(objetCourant?.deviceId) >= 25) {
        <td class="value">
          <p type="button" placement="right" [closeDelay]="4000" ngbTooltip="{{objetCourant?.deviceId}}">
            {{ formatN(objetCourant?.deviceId, 25) }}
          </p>
        </td>
        } @else {
        <td class="value">{{ objetCourant?.deviceId }}</td>
        }
      </tr>
      <tr>
        <th scope="row">{{ 'report-modal-device-industrial-name' | translate }}</th>
        <td class="value">{{ formatN(objetCourant?.deviceInfo?.industrialDeviceName, 17) }}</td>
      </tr>
      <tr>
        <th scope="row">{{ 'report-modal-device-api-lvl' | translate }}</th>
        <td class="value">{{ formatN(objetCourant?.deviceInfo?.apiLevel, 17) }}</td>
      </tr>
      <tr>
        <th scope="row">{{ 'report-modal-device-kernel-version' | translate }}</th>
        <td class="value">
          <p type="button" placement="right" [closeDelay]="4000"
            ngbTooltip="{{ formatN(objetCourant?.deviceInfo?.kernelVersion, 30) }}">
            {{ formatKernelVersion() }}
          </p>
        </td>
      </tr>
      <tr>
        <th scope="row">{{ 'report-modal-device-architecture' | translate }}</th>
        <td class="value">{{ objetCourant?.deviceInfo?.architecture }}</td>
      </tr>
    </tbody>
  </table>
  } @else {
  @if (objetCourant?.deviceInfo?.platformName?.toLowerCase() == 'android') {
  <div class="d-flex flex-row justify-content-between headandroid align-items-center justify-content-center">
    @if (modelMarque() != ('unknown-model' | translate)) {
    <div class="marque d-flex flex-row align-items-center">
      <img src="assets/icons/ModalReports/manufacters/{{modelMarque()}}.svg" alt="">
      <h2>{{ formatName(objetCourant?.deviceInfo?.model) }}</h2>
    </div>
    } @else {
    <div class="marque d-flex flex-row align-items-center">
      <h2>{{ modelMarque() }}</h2>
    </div>
    }
    <div class="osinfos d-flex flex-row align-items-center justify-content-center">
      <img src="assets/icons/logosOS/{{objetCourant?.deviceInfo?.platformName?.toLowerCase()}}.svg">
      <h2>v.{{ objetCourant?.deviceInfo?.platformVersion }}</h2>
    </div>
  </div>
  <table class="table table-borderless table-responsive">
    <tbody>
      <tr>
        <th scope="row">{{ 'report-modal-device-id' | translate }}</th>
        @if (getlength(objetCourant?.deviceId) >= 25) {
        <td class="value">
          <p type="button" placement="right" [closeDelay]="4000" ngbTooltip="{{objetCourant?.deviceId}}">
            {{ formatN(objetCourant?.deviceId, 25) }}
          </p>
        </td>
        } @else {
        <td class="value">{{ objetCourant?.deviceId }}</td>
        }
      </tr>
      <tr>
        <th scope="row">{{ 'report-modal-device-industrial-name' | translate }}</th>
        <td class="value">{{ objetCourant?.deviceInfo?.industrialDeviceName }}</td>
      </tr>
      <tr>
        <th scope="row">{{ 'report-modal-device-fingerprint' | translate }}</th>
        <td class="value fingerprint">
          <p type="button" placement="right" [closeDelay]="4000" ngbTooltip="{{objetCourant?.deviceInfo?.fingerprint}}">
            {{ formatN(objetCourant?.deviceInfo?.fingerprint, 25) }}
          </p>
        </td>
      </tr>
      <tr>
        <th scope="row">{{ 'report-modal-device-security-patch-level' | translate }}</th>
        <td class="value">{{ objetCourant?.deviceInfo?.securityPatchLevel }}</td>
      </tr>
      @if(objetCourant?.deviceInfo?.board) {
      <tr>
        <th scope="row">{{ 'report-modal-device-board' | translate }}</th>
        <td class="value">{{ objetCourant?.deviceInfo?.board }}</td>
      </tr>
      }
      <tr>
        <th scope="row">{{ 'report-modal-device-model' | translate }}</th>
        <td class="value text-capitalize">{{ objetCourant?.deviceInfo?.model }}</td>
      </tr>
      <tr>
        <th scope="row">{{ 'report-modal-device-boot-loader' | translate }}</th>
        <td class="value text-capitalize">{{ objetCourant?.deviceInfo?.bootloader }}</td>
      </tr>
      <tr>
        <th scope="row">{{ 'report-modal-device-api-lvl' | translate }}</th>
        <td class="value">{{ objetCourant?.deviceInfo?.apiLevel }}</td>
      </tr>
      <tr>
        <th scope="row">{{ 'report-modal-device-kernel-version' | translate }}</th>
        <td class="value">
          <p type="button" placement="right" [closeDelay]="4000"
            ngbTooltip="{{objetCourant?.deviceInfo?.kernelVersion}}">
            {{ formatKernelVersion() }}
          </p>
        </td>
      </tr>
      <tr>
        <th scope="row">{{ 'report-modal-device-architecture' | translate }}</th>
        <td class="value">{{ objetCourant?.deviceInfo?.architecture }}</td>
      </tr>
      <tr>
        <th scope="row">{{ 'report-modal-device-rom-model' | translate }}</th>
        <td class="value">{{ objetCourant?.deviceInfo?.romName }}</td>
      </tr>
    </tbody>
  </table>
  }
  }
</div>

<!-- Location Infos -->
@if( getContrycode() || this.objetCourant?.location?.city || objetCourant?.location?.region) {
<div class="locationInfos d-flex flex-row justify-content-center">
  <img src="assets/icons/location.svg">
  <h5>{{ getContrycode() }} <b>|</b> {{ getCity() }} <b>|</b> {{ objetCourant?.location?.region }}</h5>
</div>
}

<!-- Metadata Button -->
@if (getMetaData()) {
<div class="metadata d-flex flex-row align-items-center justify-content-center">
  <h3>{{ 'attestations-title-metadata' | translate }}</h3>
  <button type="button" class="btn btn-outline-success"
    (click)="metadata.set(getMetaData()); ldetectorsprobes.set(undefined); open({ content: content })">
    {{ 'see' | translate }}
  </button>
</div>
}

<!-- Detectors Infos (admin only) -->
<div *kaHasRoles="['bo-dip-wl-admin']; checkRealm: true" class="detectorsInfos">
  <h3>{{ 'attestations-title-detectors-sondes' | translate }}</h3>
  <div class="d-flex flex-wrap justify-content-center">
    @for (noms of listeprobes; track noms) {
    <div class="d-flex flex-column justify-content-center">
      @if (noms != 'black&White') {
      <img type="button"
        (click)="listDP.set(true); getAllProbesDetectors(noms.toLowerCase()); setFamilyselected(noms); open({ content: content })"
        id="probe-{{noms.toLowerCase()}}" src="assets/icons/probesFamilies/{{noms}}.svg">
      } @else {
      <img type="button"
        (click)="listDP.set(true); getAllProbesDetectors(noms.toLowerCase()); setFamilyselected(noms); open({ content: content })"
        id="probe-{{noms.toLowerCase()}}" src="assets/icons/probesFamilies/{{noms}}.png">
      }
      <h4 class="text-capitalize">{{ noms }}</h4>
    </div>
    }
  </div>
</div>

<!-- Modal Content -->
<ng-template #content let-c="close" let-d="dismiss">
  @if (ldetectorsprobes()) {
  <div class="modal-header">
    @if (dpdetails()) {
    <div class="d-flex flex-row align-items-center modal-back" type="button" (click)="backModal()">
      <button></button>
      <h3>{{ 'back' | translate }}</h3>
    </div>
    }
    <h2 class="modal-title" id="modal-basic-title2">{{ formatTitlePDProbes() }}</h2>
    <button type="button" class="modal-close" aria-label="Close" (click)="d('Cross click'); resetModal()"></button>
  </div>
  <div class="modal-body justify-content-center">
    <app-commons-modal-part [listContent]="dpdetails()" [mapObject]="ldetectorsprobes()"
      (probesDetailsTitle)="detailsprobestitle = $event" (dpactif)="dpdetails.set($event)">
    </app-commons-modal-part>
  </div>
  }
  @if (metadata()) {
  <div class="modal-header">
    <h2 class="modal-title" id="modal-basic-title2">{{ 'attestations-title-metadata' | translate }}</h2>
    <button type="button" class="modal-close" aria-label="Close" (click)="d('Cross click'); resetModal()"></button>
  </div>
  <div class="modal-body justify-content-center">
    <app-commons-modal-part [mapObject]="metadata()"></app-commons-modal-part>
  </div>
  }
</ng-template>